export default __webpack_public_path__ + "assets/16d33d7a455b69873cd39a1fd42cda3c.jpg";